export function getTokenContractAddress() {
    const searchParams = new URLSearchParams(
        globalThis?.window?.location?.search,
    );

    return (searchParams.get("tokenContractAddress") ||
        (globalThis?.window as unknown as { tokenContractAddress: string })
            ?.tokenContractAddress) as string;
}
